.avatar {
  color: var(--color-primary);
  background: var(--color-primary-bg);
}
